import { computed, reactive } from 'vue';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';

/* Presentation-only under v2: computes the same rich criteria as v1 for user feedback, but does
	not push a "password valid" flag anywhere since the v2 store has no such consumer/state. */
export default class PasswordValidation {
	public constructor(private readonly store: IIncentiveV2Store) {}

	public password = computed((): string => {
		const password = this.store.getters.password();
		if (password === null || typeof password === 'undefined') {
			return '';
		}
		return password;
	});

	public validationClasses = computed((): IPasswordMessageValidation => {
		return {
			min_length: !this.validation.min_length ? 'Invalid' : 'Valid',
			has_digit: !this.validation.has_digit ? 'Invalid' : 'Valid',
			has_uppercase: !this.validation.has_uppercase ? 'Invalid' : 'Valid',
			has_lowercase: !this.validation.has_lowercase ? 'Invalid' : 'Valid',
			not_empty: !this.validation.not_empty ? 'Invalid' : 'Valid',
			has_no_spaces: !this.validation.has_no_spaces ? 'Invalid' : 'Hidden',
			has_special_character: !this.validation.has_special_character ? 'Invalid' : 'Valid',
		};
	});

	public validation: IPasswordValidation = reactive({
		min_length: false,
		has_digit: false,
		has_uppercase: false,
		has_lowercase: false,
		not_empty: false,
		has_no_spaces: false,
		has_special_character: false,
	});

	public validate(): void {
		const $lower = new RegExp(/[a-z]{1,}/);
		const $upper = new RegExp(/[A-Z]{1,}/);
		const $numeric = new RegExp(/[0-9]{1,}/);
		const $space = new RegExp(/\s/);
		const $special = new RegExp(/[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]{1,}/);

		this.validation.min_length = this.password.value.length >= 12;
		this.validation.has_digit = $numeric.test(this.password.value);
		this.validation.has_uppercase = $upper.test(this.password.value);
		this.validation.has_lowercase = $lower.test(this.password.value);
		this.validation.not_empty = this.password.value.length > 0;
		this.validation.has_no_spaces = !$space.test(this.password.value);
		this.validation.has_special_character = $special.test(this.password.value);
	}
}
